export const DOMAIN_PURCHASE_INTENT_FUNNEL =
  'add-domain-purchase-intent-funnel';

export const FUNNEL_PATH = '/premium-domains/premium-funnel';

export const getFunnelSplitPageUrl = (searchParams: URLSearchParams) => {
  const params = new URLSearchParams(searchParams);
  params.set('step', 'split');

  const siteGuid = params.get('siteGuid');
  if (siteGuid) {
    params.set('msid', siteGuid);
  }

  return `${FUNNEL_PATH}/?${params.toString()}`;
};
